module.exports = __webpack_public_path__ + "media/images/riders/LUCA_SHAW-261602207f1370a0068a88a61e496e00.png";